import { apiUrl } from "./api";
import { GreenieBoardFilters, GreenieBoardResponse } from "../types/greenieBoard";

export interface FetchGreenieBoardParams extends GreenieBoardFilters {
  pilot_limit?: number;
  trap_limit?: number;
  // Restricts the board to one pilot, regardless of pilot_limit.
  pilot_uid?: string;
}

export async function fetchGreenieBoard(params: FetchGreenieBoardParams = {}): Promise<GreenieBoardResponse> {
  const url = apiUrl("/greenie_board");
  const query = new URLSearchParams();
  if (params.pilot_limit != null) query.set("pilot_limit", String(params.pilot_limit));
  if (params.trap_limit != null) query.set("trap_limit", String(params.trap_limit));
  if (params.pilot_uid) query.set("pilot_uid", params.pilot_uid);
  if (params.unit_family) query.set("unit_family", params.unit_family);
  if (params.server_id != null && params.server_id !== "") query.set("server_id", String(params.server_id));
  if (params.period && params.period !== "all_time") query.set("period", params.period);
  if (params.sort && params.sort !== "name") query.set("sort", params.sort);
  const qs = query.toString();
  const response = await fetch(qs ? `${url}?${qs}` : url);
  if (!response.ok) throw new Error(`Failed to fetch greenie board: ${response.status}`);
  return response.json();
}
